import { Directive, HostListener, Input, Renderer2, ElementRef } from '@angular/core';

@Directive({
    selector: '[appMatTableColumnResize]',
    standalone: false
})
export class MatTableColumnResizeDirective {
  private table: HTMLElement | null = null; // Initialize table as null
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    event.preventDefault();
    const initialX = event.clientX;
    const initialWidth = this.el.nativeElement.offsetWidth;
    this.table = this.findParentTable(this.el.nativeElement);
    if(!this.table) return;
    // Adjust the width of the table if it has a fixed width
    const tableWidth = this.table.offsetWidth;

    const mousemoveListener = (e: MouseEvent) => {
      const deltaX = (e.clientX - initialX);
      const newWidth = initialWidth + deltaX;
      this.renderer.setStyle(this.el.nativeElement, 'width', `${newWidth}px`);

      if (this.table) {
        this.renderer.setStyle(this.table, 'width', tableWidth + deltaX + 'px');
      }
    };

    const mouseupListener = () => {
      document.removeEventListener('mousemove', mousemoveListener);
      document.removeEventListener('mouseup', mouseupListener);
    };

    document.addEventListener('mousemove', mousemoveListener);
    document.addEventListener('mouseup', mouseupListener);
  }

  private findParentTable(element: HTMLElement): HTMLElement | null {
    while (element) {
      if (element.tagName === 'TABLE') {
        return element;
      }
      if (element?.parentElement) element = element.parentElement;
    }
    return null;
  }
  
  @HostListener('dblclick', ['$event'])
  onDoubleClick(event: Event): void {
    const targetColumn = this.el.nativeElement;

    // Create a temporary div to measure the width of the content
    const tempDiv = this.renderer.createElement('div');
    this.renderer.setStyle(tempDiv, 'position', 'absolute');
    this.renderer.setStyle(tempDiv, 'visibility', 'hidden');
    this.renderer.appendChild(tempDiv, this.renderer.createText(targetColumn.innerText));
    document.body.appendChild(tempDiv);

    // Get the width of the content
    const contentWidth = tempDiv.offsetWidth;

    // Remove the temporary div
    document.body.removeChild(tempDiv);

    // Set the column width to fit the content
    this.renderer.setStyle(targetColumn, 'width', `${contentWidth}px`);
  }
}
